export const expenselistMenuRouter = [{
  path: 'expense/list',
  icon: ' iconfont iconexpense',
  name: 'expenseList',
  title: '费用结算单',
  component: () => import('@/views/gip/expense/list.vue')
}]



// WEBPACK FOOTER //
// ./src/router/expense/expenselist.js